import { ExtractProps, withTranslations } from 'hooks/useTranslations'
import { graphql, useStaticQuery } from 'gatsby'
declare global {
  interface Snippets {
    'account-Dashboard': {
      cartpreview_your_cart: void
      cartpreview_show_cart: void
      contactbox_we_care: void
      contactbox_see_helpandservice: void
      lastorderedproducts_favorite_products: void
      lastorderedproducts_ordered_products: void
      last_seen_products: void
      dashboard_greeting: {
        name: string
      }
      dashboard_breadcrumb_home: void
      dashboard_breadcrumb_my_account: void
      dashboard_greeting_male: {
        name: string
      }
      dashboard_greeting_female: {
        name: string
      }
      dashboard_info_text: {
        LINK: any
      }
      dashboard_info_text_greeting: void
    }
  }
}

export default <C extends React.FC<ExtractProps<C>>>(Component: C) =>
  withTranslations(Component, () =>
    useStaticQuery(graphql`
      query account_Dashboard_translations {
        cartpreview_your_cart: snippet(
          group: "account-Dashboard"
          name: "cartpreview_your_cart"
        )
        cartpreview_show_cart: snippet(
          group: "account-Dashboard"
          name: "cartpreview_show_cart"
        )
        contactbox_we_care: snippet(
          group: "account-Dashboard"
          name: "contactbox_we_care"
        )
        contactbox_see_helpandservice: snippet(
          group: "account-Dashboard"
          name: "contactbox_see_helpandservice"
        )
        lastorderedproducts_favorite_products: snippet(
          group: "account-Dashboard"
          name: "lastorderedproducts_favorite_products"
        )
        lastorderedproducts_ordered_products: snippet(
          group: "account-Dashboard"
          name: "lastorderedproducts_ordered_products"
        )
        last_seen_products: snippet(
          group: "account-Dashboard"
          name: "last_seen_products"
        )
        dashboard_greeting: snippet(
          group: "account-Dashboard"
          name: "dashboard_greeting"
        )
        dashboard_breadcrumb_home: snippet(
          group: "account-Dashboard"
          name: "dashboard_breadcrumb_home"
        )
        dashboard_breadcrumb_my_account: snippet(
          group: "account-Dashboard"
          name: "dashboard_breadcrumb_my_account"
        )
        dashboard_greeting_male: snippet(
          group: "account-Dashboard"
          name: "dashboard_greeting_male"
        )
        dashboard_greeting_female: snippet(
          group: "account-Dashboard"
          name: "dashboard_greeting_female"
        )
        dashboard_info_text: snippet(
          group: "account-Dashboard"
          name: "dashboard_info_text"
        )
        dashboard_info_text_greeting: snippet(
          group: "account-Dashboard"
          name: "dashboard_info_text_greeting"
        )
      }
    `)
  )
